import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { DialogService } from 'shared';
import { UserGeolocationService } from 'src/app/core/services/user-geolocation.service';
import { environment } from 'src/environments/environment';
import { AppStoreActions } from '../../store/app.store.actions';
import { AppStoreModel } from '../../store/app.store.model';
import { APP_STATE_TOKEN } from '../../store/app.store.state';
import { ModalCambiarUbicacionComponent } from '../modals/modal-cambiar-ubicacion/modal-cambiar-ubicacion.component';
import { ModalPorQueUbicarmeComponent } from '../modals/modal-por-que-ubicarme/modal-por-que-ubicarme.component';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit {

  @Select(APP_STATE_TOKEN) appState$: Observable<AppStoreModel>;

  urlExterno = environment.baseUrlAPIEXT;

  @ViewChild('header') header: ElementRef<HTMLElement>;

  constructor(
    private store: Store,
    private dialogService: DialogService,
    private userGeolocationService: UserGeolocationService
  ) { }

  ngOnInit(): void {
  }

  handleClickLogout = () => {
    this.store.dispatch(new AppStoreActions.Session.Logout());
  }

  handleChangeDefaultRol = (e) => {
    this.store.dispatch(new AppStoreActions.Session.SetRol({
      rol: parseInt(e.target.value)
    })).subscribe(() => {
      const { session } = this.store.selectSnapshot(APP_STATE_TOKEN);

      this.store.dispatch(new AppStoreActions.Session.GetPermisos());
      this.store.dispatch(new AppStoreActions.Session.GetRawMenu({
        idPerfil: session.session.defaultRol
      }));
    });
    // ver si se guarda en local storage
  }

  handleToogleMenu = (opened: boolean) => {
    this.store.dispatch(new AppStoreActions.Ui.HideSidebar(opened));
  }

  handleRemoveUbicacion = () => {
    this.userGeolocationService.removeGeolocation();
  }

  handleOpenModalPorQueUbicarme = () => {
    this.dialogService.openSM(ModalPorQueUbicarmeComponent);
  }

  handleOpenModalCambiarUbicacion = () => {
    this.dialogService.openMD(ModalCambiarUbicacionComponent);
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e) {
    // console.log(window.scrollY);
    if (window.scrollY > 110) {
      this.header.nativeElement.classList.add('sticky-toolbar');
    } else {
      this.header.nativeElement.classList.remove('sticky-toolbar');
    }
  }

  handleCloseSidenav = () => {
    this.store.dispatch(new AppStoreActions.Ui.HideSidebar(true));
  }
}
